let pageNumber = 1;
//Function for filtering
export function SearchResultsFilter(){
    (function($) {
        function search_result_filter(checkedValues, searchTerm){
            let window_size = $(window).width();
            pageNumber = 1;
            $.ajax({
                url: ajax_carousel_posts.ajax_url, // La variabile ajax_url è fornita da WordPress
                type: 'post',
                data: {
                    action: 'search_results_filter',
                    windowSize: window_size,
                    pageNumber: pageNumber,
                    postType: JSON.stringify(checkedValues),
                    searchTerm : searchTerm,
                },
                success: function(response) {
                    // Accedi ai valori dalla risposta
                    let htmlContent = response.html;
                    let hasMorePosts = response.has_more_posts;
                    let totalItems = response.total_items;
                    if(!totalCount > 0 ){
                        //$('.search_filters').hide();
                    }
                    $('.search_results_count p strong').text(totalItems);
    
                   // Utilizza i valori come necessario
                    $('#search_results_ajax').html(htmlContent);
                    if(!hasMorePosts){
                        //$("#more_insights").hide();
                    }
                },
                error: function(error) {
                    console.log(error);
                }
            });
            return false;
        }
    
        //load_people();
        let checkAll = $('#checkAll');
        let checkboxes = $('.postTypeCheckbox');
        let allVal = [];
        let searchTerm = $('.search_filters').data('search');
        let totalCount = $('.search_results_count p strong').text();
        var checkedValues = [];

        checkboxes.each(function() {
            checkedValues.push($(this).val());
        });
        search_result_filter(checkedValues, searchTerm);

        //console.log("checkd: " + checkedValues);
        //console.log("result: " + search_result_filter(checkedValues, searchTerm));

        checkboxes.each(function() {
            allVal.push($(this).val());
        })
        checkAll.val(allVal.join(','));

        checkboxes.on('change', function() {
            checkAll.closest('.container_label').removeClass('active');
            var checkedValues = [];

            checkboxes.each(function() {
                if ($(this).is(':checked')) {
                    checkAll.prop('checked', false);
                    checkedValues.push($(this).val());
                }
            });

            // Chiamata alla tua funzione di filtro
            search_result_filter(checkedValues, searchTerm);
        });
        checkAll.on('change', function() {
            var checkedValues = [];
            if (checkAll.is(':checked')) {
                checkboxes.prop('checked', false);
                checkboxes.each(function() {
                    checkedValues.push($(this).val());
                });
                $('.search_results_count p strong').text(totalCount);
            }

            // Chiamata alla tua funzione di filtro
            search_result_filter(checkedValues, searchTerm);
        });
    
    })(jQuery);
}
    
//Function for load more of listing items
export function AjaxLoadInsights(){
    (function($) {
        let window_size = $(window).width();
        let ppp = 9;// Post per page
        //let pageNumber = 1;
        
        function load_posts_insights(competence_id, tipologia_id, geo_id, year, text_input, tag_id){
            pageNumber++;
            $('p#loading_text').show();
            $("#more_insights").hide();
            $.ajax({
                type: "POST",
                dataType: "html",
                url: ajax_posts.ajaxurl,
                data: {
                    action: 'more_insights_ajax',
                    competenceID: competence_id,
                    tipologiaID: tipologia_id,
                    geoID: geo_id,
                    year: year,
                    textInput: text_input,
                    tagID: tag_id,
                    windowSize: window_size,
                    pageNumber: pageNumber,
                    ppp: ppp
                },
                success: function(data){
                    let $data = $(data);
                    if($data.length){
                        $("#ajax_content_insights").append($data);
                        $('p#loading_text').hide();
                        $("#more_insights").show();
                        $("#more_insights").attr("disabled",false); // Uncomment this if you want to disable the button once all posts are loaded
                    }else{
                        $("#more_insights").hide(); // This will hide the button once all posts have been loaded
                        $('p#loading_text').hide();
                    }
                },
                error : function(jqXHR, textStatus, errorThrown) {
                    //$loader.html(jqXHR + " :: " + textStatus + " :: " + errorThrown);
                }
        
            });
            return false;
        }
        
        $("#more_insights").on("click",function(e){ // When btn is pressed.
            e.preventDefault();
            let geo_id = $('#geo_area_posts_select').val();
            let year = $('#years_select').val();
            let tipologia_id = $('#tipologia_posts_select').val();
            let competence_id = $('#competence_area_posts_select').val();
            let text_input = $('#custom_search_input_text').val();
            let tag_id = $('.tag_item.active').data('tag');
            load_posts_insights(competence_id, tipologia_id, geo_id, year, text_input, tag_id);
        });
    })(jQuery);
}
    